import React, { Component } from "react";
import {
  Form,
  Input,
  Button,
  message,
} from "antd";

import axios from "axios";

export default class Notifications extends Component {
  formRef = React.createRef();

  constructor(props) {
    super(props);

    this.state = {
      title: "",
      text: "",
      loading: false,
    };

    this.onFinish = this.onFinish.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onFinishFailed = this.onFinishFailed.bind(this);
  }

  onFinish(values) {
    console.log("Success:", values);

     axios
      .post(`${process.env.REACT_APP_SERVER_URL}/api/notifications`, values)
      .then((response) => {
        console.log(response);

        this.setState({ loading: false });

        if (response.status === 200) {
          message.success("notifica mandata con successo");
          this.formRef.current.resetFields();
        }
      })
      .catch((error) => {
        console.log(error);

        message.error("E' successo un errore durante l'invio delle notifiche");
      });
  }

  onChange() {
    console.log("stuff changed");
  }

  onFinishFailed(errorInfo) {
    console.log("Failed:", errorInfo);
  }

  render() {
    return (
      <div id="notifications_box">
        <Form
          onFinish={this.onFinish}
          onFinishFailed={this.onFinishFailed}
          initialValues={{}}
          ref={this.formRef}
        >
          <Form.Item
            label="Titolo Notifica"
            name="title"
            rules={[
              {
                required: true,
                message: "Il titolo e' obbligatorio",
              },
            ]}
          >
            <Input placeholder="Titole della notifica" type="text" />
          </Form.Item>
          <Form.Item
            name="text"
            label="text"
            rules={[
              {
                required: true,
                message: "Il testo e' obbligatorio",
              },
            ]}
          >
            <Input.TextArea
              placeholder="Il contenuto della notifica (massimo 50 caratteri)"
              type="text"
            />
          </Form.Item>

          <div style={{ display: "flex", justifyContent: "center" }}>
            <Form.Item>
              <Button size="large" type="primary" htmlType="submit">
                Manda
              </Button>
            </Form.Item>
          </div>
        </Form>
      </div>
    );
  }
}
